import React, { memo } from 'react';
import { StatusTag } from '../../common/components/StatusTag';
import { SystemClassifierItem } from '../../systemClassifier/SystemClassifierItem';

export interface ValidationStatusProps {
  itemId?: number;
}

export const ValidationStatus = memo(({ itemId }: ValidationStatusProps) => (
  <SystemClassifierItem
    code="VALIDATION_RULE_STATUS"
    itemId={itemId}
    render={(val) => (val ? <StatusTag status={val.code} /> : null)}
  />
));
